import React from 'react';
import View from './View';
import StyleSheet from './StyleSheet';
import './ScrollView.css';
export default class ScrollView extends React.Component {
  componentDidMount() {
    let {ref} = this.props;
    ref && ref(this);
  }

  scrollToEnd = () => {
    if (this.ref) {
      let {scrollWidth, clientWidth} = this.ref;
      let scrollTo = scrollWidth - clientWidth;
      this.ref.scrollLeft = scrollTo;
    }
  };

  onScroll = e => {
    let eventValues = e.target;
    let {onScroll} = this.props;
    onScroll && onScroll(eventValues);
  };

  render() {
    let {
      style,
      contentContainerStyle,
      keyboardShouldPersistTaps,
      showsVerticalScrollIndicator = true,
      showsHorizontalScrollIndicator = true,
      horizontal,
      getRef,
      className = '',
      ...restProps
    } = this.props;
    if (Array.isArray(style)) {
      style = StyleSheet.flatten(style);
    }
    if (contentContainerStyle && Array.isArray(contentContainerStyle)) {
      contentContainerStyle = StyleSheet.flatten(contentContainerStyle);
    }
    // This is for hide-vertical-scroll-indicator we use css class for hide it and add to className and Pass
    if (!showsVerticalScrollIndicator) {
      className += ' hide-vertical-scroll-indicator';
    }
    // This is for hide-horizontal-scroll-indicator
    if (!showsHorizontalScrollIndicator) {
      className += ' hide-horizontal-scroll-indicator';
    }
    style = {...style, ...contentContainerStyle, overflow: 'auto'};
    if (horizontal) {
      style['flexDirection'] = 'row';
    }
    return (
      <View
        className={className}
        getRef={e => {
          this.ref = e;
          getRef && getRef(e);
        }}
        {...restProps}
        style={style}
        onScroll={this.onScroll}
      />
    );
  }
}
